export default {
  OK: "OK",
  ok: "OK",
  loginFailed: "Log masuk gagal, sila cuba lagi.",
  requestFailed: "Permintaan gagal, sila periksa sambungan internet anda.",
  invalidLogin: "Nama Pengguna atau Kata Laluan tidak sah.",
  thisFunctionExists: "Fungsi ini sudah wujud.",
  thisFunctionNotAllowDelete: "Fungsi ini tidak dibenarkan untuk dipadam.",
  thisFunctionNotExists: "Fungsi ini tidak wujud.",
  targetFunctionIdRequired: "ID Fungsi Sasaran diperlukan.",
  thisPageExists: "Halaman ini sudah wujud.",
  thisPageNotAllowDelete: "Halaman ini tidak dibenarkan untuk dipadam.",
  thisRoleExists: "Peranan ini sudah wujud.",
  thisRoleNotAllowDelete: "Peranan ini tidak dibenarkan untuk dipadam.",
  targetRoleIdRequired: "ID Peranan Sasaran diperlukan.",
  invalidParameter: "Parameter tidak sah.",
  systemError: "Sistem tidak dapat memproses permintaan anda.",
  spErrorMessage: "Ralat Mesej SP (Bergantung pada ralat apa).",
  actionbyRequired: "Pengguna Semasa diperlukan.",
  sessionTokenRequired: "Token Sesi diperlukan.",
  functionIdRequired: "ID Fungsi diperlukan.",
  functionNameRequired: "Nama Fungsi diperlukan.",
  newFunctionNameRequired: "Nama Fungsi diperlukan.",
  pageIdRequired: "Page ID diperlukan.",
  newPageIdRequired: "ID Halaman diperlukan.",
  newPageNameRequired: "Nama Halaman diperlukan.",
  targetPageIdRequired: "ID Halaman Sasaran diperlukan.",
  passwordRequired: "Kata laluan diperlukan.",
  userNameRequired: "Nama Penuh diperlukan.",
  passwordValidation: "Kata laluan mesti antara 6-20 aksara dan mengandungi gabungan nombor dan huruf.",
  pageNumRequired: "Nombor Halaman diperlukan.",
  pageSizeRequired: "Saiz Halaman diperlukan.",
  roleIdRequired: "ID Peranan diperlukan.",
  oldPasswordRequired: "Kata Laluan Semasa diperlukan.",
  userStatusRequired: "Status Pengguna diperlukan.",
  newRoleIdRequired: "ID Peranan diperlukan.",
  newRoleNameRequired: "Nama Peranan diperlukan.",
  startDateIsGteEndDate: "Tarikh Mula lebih besar daripada Tarikh Tamat.",
  thisRoleNotExists: "Peranan ini tidak wujud.",
  thisPageNotExists: "Halaman ini tidak wujud.",
  thisUserExists: "Pengguna ini sudah wujud.",
  thisUserNotExists: "Pengguna ini tidak wujud.",
  thisUserBlackListed: "Akaun anda telah digantung.",
  thisUserInactive: "Akaun anda telah dinyahaktifkan.",
  thisUserBlocked: "Akaun anda telah disekat.",
  thisUserNotActive: "Akaun anda telah dinyahaktifkan.",
  InvalidPageFunction: "Fungsi Halaman Tidak Sah.",
  invalidUser: "Pengguna Tidak Sah!",
  invalidToken: "Sesi Tidak Sah!",
  NoUserAccessRight: "Kebenaran Ditolak!",
  connection: "Ralat Sambungan.",
  profileIdRequired: "ID Profil diperlukan.",
  packageIdRequired: "ID Pakej diperlukan.",
  fullNameMinThreeChar: "Nama penuh mesti sekurang-kurangnya 3 aksara.",
  accountIdMinThreeChar: "ID Akaun mesti sekurang-kurangnya 3 aksara.",
  searchCriteriaRequired: "Kriteria carian diperlukan.",
  affiliateIdRequired: "Id afiliasi diperlukan",
  minDepositRequired: "Minimum deposit diperlukan.",
  bonusRateRequired: "Kadar Bonus diperlukan.",
  onlyAllowRejectDeposit: "Hanya boleh menolak tiket deposit.",
  senderBankIdRequired: "Sender bank ID diperlukan.",
  senderBankAccNoRequired: "Sender bank account number diperlukan.",
  minFTDAmtNumOnly: "Jumlah FTD Min hanya menerima angka.",
  maxFTDAmtNumOnly: "Jumlah FTD Maks hanya menerima angka.",
  crmBasicCriteriaRequired: "ID Ahli / Telefon / E-mel / Tarikh Daftar / Tarikh Log Masuk Terakhir diperlukan.",
  verifiedDateRangeAllowThreeMonths: "Julat tarikh daftar hanya dibenarkan sehingga 3 bulan.",
  lastLoginDateRangeAllowThreeMonths: "Julat tarikh log masuk terakhir hanya dibenarkan sehingga 3 bulan.",
  depositDateRangeAllowThreeMonths: "Julat tarikh deposit hanya dibenarkan sehingga 3 bulan.",
  ftdDateRangeAllowThreeMonths: "Julat tarikh FTD hanya dibenarkan sehingga 3 bulan.",
  ltdDateRangeAllowThreeMonths: "Julat tarikh LTD hanya dibenarkan sehingga 3 bulan.",
  lastLoginDateEarlierThanVerifiedDate: "Tarikh log masuk terakhir lebih awal daripada tarikh daftar.",
  depositDateEarlierThanVerifiedDate: "Tarikh deposit lebih awal daripada tarikh daftar.",
  ftdDateEarlierThanVerifiedDate: "Tarikh FTD lebih awal daripada tarikh daftar.",
  ltdDateEarlierThanVerifiedDate: "Tarikh LTD lebih awal daripada tarikh daftar.",
  ftdFromRequired: "Tarikh mula FTD diperlukan.",
  ftdToRequired: "Tarikh tamat FTD diperlukan.",
  ltdFromRequired: "Tarikh mula LTD diperlukan.",
  ltdToRequired: "Tarikh tamat LTD diperlukan.",
  failedToLaunchPaymentGateway: "Gagal melancarkan gerbang pembayaran.",
  enTitleRequired: "Tajuk EN diperlukan.",
  enBodyRequired: "Badan EN diperlukan.",
  enImageUrlRequired: "URL Imej EN diperlukan.",
  enImageUrlDesktopRequired: "URL Imej Desktop EN diperlukan.",
  enAltRequired: "Alt EN diperlukan.",
  enHrefRequired: "Href EN diperlukan.",
  resubmitTicketRequired: "Resubmit ticket diperlukan.",
  withtholdBonusAndAmountGreaterThanZero: "Bonus dan jumlah penahanan tidak boleh lebih besar daripada sifar pada masa yang sama.",
  maxWithdrawMultipleAndAmountGreaterThanZero: "Pengeluaran maksimum dan jumlah pengeluaran maksimum tidak boleh lebih besar daripada sifar pada masa yang sama.",
  serverBusy: "Pelayan sedang sibuk. Sila cuba lagi.",
  isRequired: "Sila masukkan {fname}.",
  isMinValue: "{fname} mesti mempunyai sekurang-kurangnya {fvalue}.",
  isMaxValue: "{fname} mesti kurang daripada atau sama dengan {fvalue}.",
  isMinLength: "{fname} mesti mempunyai sekurang-kurangnya {fvalue} aksara.",
  isMaxLength: "{fname} mesti kurang daripada atau sama dengan {fvalue} aksara.",
  isAlpha: "{fname} hanya menerima huruf.",
  isAlphaNum: "{fname} hanya menerima alfanumerik.",
  isNumeric: "{fname} hanya menerima angka.",
  isEmail: "{fname} hanya menerima alamat e-mel yang sah.",
  isIpAddress: "{fname} hanya menerima alamat IPv4 yang sah.",
  isSameAs: "{fname} mesti sama dengan {fname2}",
  isUrl: "{fname} hanya menerima URL.",
  containAlphaNum: "{fname} mesti mempunyai sekurang-kurangnya satu huruf dan satu nombor.",
  alphaNumWithSpace: "{fname} hanya menerima alfanumerik.",
  isDecimal: "{fname} hanya menerima angka.",
  isInteger: "{fname} hanya menerima integer.",
  selectOption: "Sila pilih {fname}",
  notSameAs: "{fname} dan {fname2} tidak boleh sama.",
  dateRangeAllowOneMonth: "Julat tarikh hanya boleh dipilih sehingga 1 bulan.",
  dateRangeAllowOneYear: "Julat tarikh hanya boleh dipilih sehingga 1 tahun.",
  greaterThanZero: "{fname} mesti lebih besar daripada sifar.",
  atLeastOneAuthority: "Mesti memilih sekurang-kurangnya satu autoriti.",
  BLOCK: "Akaun anda telah disekat.",
  SUSPEND: "Akaun anda telah digantung.",
  CLOSE: "Akaun anda telah ditutup.",
  RESETL: "Akaun anda telah diset semula.",
  atLeastOneProvider: "Mesti memilih sekurang-kurangnya satu pembekal.",
  failedToGetResultUrl: "Gagal mendapatkan URL keputusan.",
  fileSizeValidation: "Terlalu besar, saiz maksimum yang dibenarkan ialah 1mb.",
  atLeastOnePaymentOption: "Mesti memilih sekurang-kurangnya satu pilihan pembayaran.",
  atLeastOnePaymentGateway: "Mesti memilih sekurang-kurangnya satu gerbang pembayaran.",
  dateRangeAllow31Days: "Julat tarikh hanya boleh dipilih sehingga 31 hari.",
  dateRangeAllow31Months: "Julat tarikh hanya boleh dipilih sehingga 31 bulan.",
  dateRangeAllow31Years: "Julat tarikh hanya boleh dipilih sehingga 31 tahun.",
  invalidCategory: "Kategori tidak sah",
  noChanges: "Tiada perubahan",
  permissionDenied: "Kebenaran ditolak",
  referralCodeRequired: "Kod rujukan diperlukan",
  providerDescRequired: "Huraian pembekal diperlukan",
  marqueeContentRequired: "Kandungan marquee diperlukan.",
  bonusNameRequired: "Nama bonus diperlukan.",
  baseAmountRequired: "Jumlah asas diperlukan.",
  reviewIdRequired: "ID ulasan diperlukan.",
  surveyIdRequired: "ID kaji selidik diperlukan.",
  questionRequired: "Soalan diperlukan.",
  iframeIdRequired: "ID iframe diperlukan.",
  bonusAmountRequired: "Jumlah bonus diperlukan.",
  inboxIdRequired: "ID peti masuk diperlukan.",
  exchangedAmountRequired: "Jumlah pertukaran diperlukan.",
  baseRateRequired: "Kadar asas diperlukan.",
  exchangeRateRequired: "Kadar pertukaran diperlukan.",
  baseCurrencyRequired: "Mata wang asas diperlukan.",
  exchangeCurrencyRequired: "Mata wang pertukaran diperlukan.",
  depositTypeRequired: "Jenis deposit diperlukan.",
  nbRedepositRequired: "Nb redeposit diperlukan.",
  bankOwnerRequired: "Pemilik bank diperlukan.",
  autoSenderRequired: "Penghantar automatik diperlukan.",
  isRecommendRequired: "Cadangan diperlukan.",
  recipientBankIdRequired: "ID bank penerima diperlukan.",
  recipientBankAccNoRequired: "Nombor akaun bank penerima diperlukan.",
  accountBalanceRequired: "Baki akaun diperlukan.",
  incomingAmountThresholdRequired: "Ambang jumlah masuk diperlukan.",
  incomingFrequencyThresholdRequired: "Ambang kekerapan masuk diperlukan.",
  outgoingAmountThresholdRequired: "Ambang jumlah keluar diperlukan.",
  outgoingFrequencyThresholdRequired: "Ambang kekerapan keluar diperlukan.",
  bankAccTypeRequired: "Jenis akaun bank diperlukan.",
  packageRequired: "Pakej diperlukan.",
  rtpRequired: "RTP diperlukan.",
  domainIdRequired: "ID domain diperlukan.",
  buyOnBehalfRequired: "Pembelian bagi pihak diperlukan.",
  serviceProviderRequired: "Penyedia perkhidmatan diperlukan.",
  serverAccountRequired: "Akaun pelayan diperlukan.",
  nameServerRequired: "Pelayan nama diperlukan.",
  socialLinkRequired: "Pautan sosial diperlukan.",
  newSocialPlatformRequired: "Platform sosial baharu diperlukan.",
  attachmentPathRequired: "Laluan lampiran diperlukan.",
  depositMethodRequired: "Kaedah deposit diperlukan.",
  depositDateRequired: "Tarikh deposit diperlukan.",
  refNoRequired: "Nombor rujukan diperlukan.",
  withdrawalAmountRequired: "Jumlah pengeluaran diperlukan.",
  targetBankAccNoRequired: "Nombor akaun bank sasaran diperlukan.",
  targetBankIdRequired: "ID bank sasaran diperlukan.",
  jsonRatingRequired: "Penilaian JSON diperlukan.",
  startTimeRequired: "Masa mula diperlukan.",
  accountIdRequired: "ID akaun diperlukan.",
  parentIdRequired: "ID ibu bapa diperlukan.",
  amountRequired: "Jumlah diperlukan.",
  clientIpRequired: "IP pelanggan diperlukan.",
  auditByRequired: "Diperiksa oleh diperlukan.",
  systemTypeRequired: "Jenis sistem diperlukan.",
  currencyRequired: "Mata wang diperlukan.",
  ipAddressRequired: "Alamat IP diperlukan.",
  affiliateCodeRequired: "Kod afiliasi diperlukan.",
  contactPhoneRequired: "Nombor telefon diperlukan.",
  requestTypeRequired: "Jenis permintaan diperlukan.",
  securityDisabledRequired: "Keselamatan dinyahaktifkan diperlukan.",
  gameCodeRequired: "Kod permainan diperlukan.",
  seqRequired: "Turutan diperlukan.",
  minLimitRequired: "Had minimum diperlukan.",
  maxLimitRequired: "Had maksimum diperlukan.",
  commSportsRequired: "Komisen untuk sukan diperlukan.",
  commSlotsRequired: "Komisen untuk slot diperlukan.",
  commLivecasinoRequired: "Komisen untuk kasino langsung diperlukan.",
  commCockfightRequired: "Komisen untuk sabung ayam diperlukan.",
  commOthersRequired: "Komisen untuk lain-lain diperlukan.",
  settingValueRequired: "Nilai tetapan diperlukan.",
  vipIdRequired: "VIP ID diperlukan.",
  carryOverRequired: "Carry over diperlukan.",
  campaignIdRequired: "Campaign ID diperlukan.",
  titleRequired: "Title diperlukan.",
  bodyRequired: "Body diperlukan.",
  itemOrderRequired: "Item order diperlukan.",
  imageUrlRequired: "Image URL diperlukan.",
  bannerIdRequired: "Banner ID diperlukan.",
  directionRequired: "Direction diperlukan.",
  defaultOrderRequired: "Default order diperlukan.",
  altRequired: "Alt text diperlukan.",
  hrefRequired: "Href diperlukan.",
  targetWindowRequired: "Target window diperlukan.",
  loginRequiredRequired: "Login required diperlukan.",
  activeFromRequired: "Active from diperlukan.",
  activeToRequired: "Active to diperlukan.",
  bannerTypeRequired: "Banner type diperlukan.",
  pageNameRequired: "Page name diperlukan.",
  remarkRequired: "Remark diperlukan.",
  settingKeyRequired: "Setting key diperlukan.",
  memberListRequired: "Member list diperlukan.",
  memberIdRequired: "ID Ahli diperlukan.",
  workingMonthRequired: "Working month diperlukan.",
  workingDateRequired: "Working date diperlukan.",
  tacRequired: "Terms and conditions diperlukan.",
  paymentModeRequired: "Payment mode diperlukan.",
  newPasswordRequired: "New password diperlukan.",
  loginIdRequired: "Login ID diperlukan.",
  securityTagRequired: "Security tag diperlukan.",
  securityCodeRequired: "Security code diperlukan.",
  providerCodeRequired: "Provider code diperlukan.",
  startDateRequired: "Start date diperlukan.",
  endDateRequired: "End date diperlukan.",
  searchIdRequired: "Search ID diperlukan.",
  authTokenRequired: "Auth token diperlukan.",
  newStatusRequired: "New status diperlukan.",
  actionRequired: "Action diperlukan.",
  promotionIdRequired: "Promotion ID diperlukan.",
  promotionNameRequired: "Promotion name diperlukan.",
  rolloverRequired: "Rollover diperlukan.",
  criteriaRequired: "Criteria diperlukan.",
  ticketIdRequired: "Ticket ID diperlukan.",
  resultIdRequired: "Result ID diperlukan.",
  bankIdRequired: "Bank ID diperlukan.",
  bankAccNoRequired: "Bank account number diperlukan.",
  bankAccHolderRequired: "Bank account holder diperlukan.",
  newBankIdRequired: "New bank ID diperlukan.",
  newBankAccNoRequired: "New bank account number diperlukan.",
  newBankAccHolderRequired: "New bank account holder diperlukan.",
  fullNameRequired: "Full name diperlukan.",
  depositAmountRequired: "Deposit amount diperlukan.",
  gatewayAccRequired: "Gateway account diperlukan.",
  labelNameRequired: "Label name diperlukan.",
  labelIdRequired: "Label ID diperlukan.",
  bankTypeRequired: "Bank type diperlukan.",
  amountLimitRequired: "Amount limit diperlukan.",
  currencyRateRequired: "Currency rate diperlukan.",
  urlRequired: "URL diperlukan.",
  cashRequired: "Cash diperlukan.",
  csRequired: "Customer support diperlukan.",
  vipNameRequired: "VIP name diperlukan.",
  campaignNameRequired: "Campaign name diperlukan.",
  transferIdRequired: "Transfer ID diperlukan.",
  betTimeRequired: "Bet time diperlukan.",
  turnoverRequired: "Turnover diperlukan.",
  payoutRequired: "Payout diperlukan.",
  winloseRequired: "Win/Lose diperlukan.",
  rawMessageRequired: "Raw message diperlukan.",
  authStatusRequired: "Auth status diperlukan.",
  dateRequired: "Date diperlukan.",
  betIdRequired: "Bet ID diperlukan.",
  betStatusRequired: "Bet status diperlukan.",
  betAmountRequired: "Bet amount diperlukan.",
  isParlayRequired: "Is parlay diperlukan.",
  isAddonRequired: "Is addon diperlukan.",
  withholdBonusRequired: "Withhold bonus diperlukan.",
  withholdAmountRequired: "Withhold amount diperlukan.",
  maxWithdrawAmountRequired: "Maximum withdraw amount diperlukan.",
  betTypeRequired: "Bet type diperlukan.",
  maxWithdrawMultipleRequired: "Max withdraw multiple diperlukan.",
  socialPlatformRequired: "Social platform diperlukan.",
  vipProviderRebateRequired: "VIP provider rebate diperlukan.",
  selfRebateRateRequired: "Self rebate rate diperlukan.",
  downlineRebateRateRequired: "Downline rebate rate diperlukan.",
  tierIdRequired: "Tier ID diperlukan.",
  rebateRateRequired: "Rebate rate diperlukan.",
  paymentGatewayRequired: "Payment gateway diperlukan.",
  rescueIdRequired: "Rescue ID diperlukan.",
  rescueNameRequired: "Rescue name diperlukan.",
  rescueCycleRequired: "Rescue cycle diperlukan.",
  minLoseRequired: "Minimum lose diperlukan.",
  rescueRateRequired: "Rescue rate diperlukan.",
  maxPayoutRequired: "Maximum payout diperlukan.",
  payoutMethodRequired: "Payout method diperlukan.",
  targetGroupRequired: "Target group diperlukan.",
  maintainDepositRequired: "Maintain deposit diperlukan.",
  maintainTurnoverRequired: "Maintain turnover diperlukan.",
  depositOrTurnoverRequired: "Deposit atau turnover diperlukan.",
  maintainDepositOrMaintainTurnoverRequired: "Maintain deposit atau maintain turnover diperlukan.",
  vipListRequired: "VIP list diperlukan.",
  gameNameRequired: "Game name diperlukan.",
  claimTypeRequired: "Claim type diperlukan.",
  operatorIdRequired: "Operator ID diperlukan.",
  maxBonusRequired: "Max bonus diperlukan.",
  endTimeRequired: "End time diperlukan.",
  mondayRequired: "Monday diperlukan.",
  tuesdayRequired: "Tuesday diperlukan.",
  wednesdayRequired: "Wednesday diperlukan.",
  thursdayRequired: "Thursday diperlukan.",
  fridayRequired: "Friday diperlukan.",
  saturdayRequired: "Saturday diperlukan.",
  sundayRequired: "Sunday diperlukan.",
  promotionTypeRequired: "Promotion type diperlukan.",
  claimLimitRequired: "Claim limit diperlukan.",
  bonusRate1Required: "Bonus rate 1 diperlukan.",
  bonusRate1To2Required: "Kadar bonus 1 hingga 2 diperlukan.",
  bonusRate1To3Required: "Kadar bonus 1 hingga 3 diperlukan.",
  bonusRate1To4Required: " Kadar bonus 1 hingga 4 diperlukan.",
  bonusRate1To5Required: " Kadar bonus 1 hingga 5 diperlukan.",
  bonusRate1To6Required: " Kadar bonus 1 hingga 6 diperlukan.",
  bonusRate1To7Required: " Kadar bonus 1 hingga 7 diperlukan.",
  externalIdRequired: "ID luaran diperlukan.",
  opsiteRequired: "Sebaliknya diperlukan.",
  opsiteContentRequired: "Kandungan bertentangan diperlukan.",
  opsiteLanguageRequired: "Bahasa bertentangan diperlukan.",
  opsitePaymentRequired: "Bayaran bertentangan diperlukan.",
  opsiteProviderRequired: "Pembekal bertentangan diperlukan.",
  opsiteProviderGamesRequired: "Permainan pembekal bertentangan diperlukan.",
  accountTypeRequired: "Jenis akaun diperlukan.",
  domainNameRequired: "Nama domain diperlukan.",
  settledTimeRequired: "Masa yang ditetapkan diperlukan.",
  validTurnoverRequired: "Perolehan yang sah diperlukan.",
  resultTimeRequired: "Masa keputusan diperlukan.",
  resultStatusRequired: "Status keputusan diperlukan.",
  secondIdRequired: "ID kedua diperlukan.",
  domainListRequired: "Senarai domain diperlukan.",
  domainTypeRequired: "Jenis domain diperlukan.",
  moduleRequired: "Modul diperlukan.",
  gameIdRequired: "ID permainan diperlukan.",
  gameDetailRequired: "Detail permainan diperlukan.",
  bonusRate1To8Required: "Kadar bonus 1 hingga 8 diperlukan.",
  bonusRate1To9Required: "Kadar bonus 1 hingga 9 diperlukan.",
  bonusRate1To10Required: "Kadar bonus 1 hingga 10 diperlukan.",
  invalidOrder: "Pesanan tidak sah.",
  bannerNotExists: "Bendera tidak wujud.",
  invalidBannerType: "Jenis bendera tidak sah.",
  pageNameExists: "Nama halaman wujud.",
  pageNotExists: "Halaman tidak wujud.",
  tacIsValid: "OTP sah.",
  invalidTac: "OTP tidak sah.",
  tacExpired: "OTP telah tamat tempoh.",
  tacNotValidate: "OTP tidak disahkan.",
  paymentModeNotExists: "Mod pembayaran tidak wujud.",
  paymentOptionProviderNotExists: "Penyedia pilihan pembayaran tidak wujud.",
  ipAddressExists: "Alamat IP wujud.",
  ticketProcessed: "Tiket diproses.",
  bankAccountNotExists: "Akaun bank tidak wujud.",
  bankAccountInactive: "Akaun bank tidak aktif.",
  bankMemberNotExists: "Ahli bank tidak wujud.",
  bankMemberInactive: "Ahli bank tidak aktif.",
  affiliateExists: "Ahli gabungan wujud.",
  contactPhoneExists: "Telefon hubungan wujud.",
  affiliateFull: "Ahli gabungan penuh.",
  uplineInactive: "Upline tidak aktif.",
  applicationProcessed: "Permohonan diproses.",
  tacValidated: "Terma dan syarat disahkan.",
  applicationPending: "Permohonan tertangguh.",
  favouriteGameExists: "Permainan kegemaran wujud.",
  invalidLimit: "Had tidak sah.",
  settingNotSet: "Tetapan tidak ditetapkan.",
  domainNameNotExists: "Nama domain tidak wujud.",
  domainNameFull: "Nama domain penuh.",
  domainNameNotAvailable: "Nama domain tidak tersedia.",
  domainNameExists: "Nama domain wujud.",
  subAccountNotExists: "Akaun sub tidak wujud.",
  settingNotExists: "Tetapan tidak wujud.",
  invalidContactEmail: "Emel kontak tidak sah.",
  accountInactive: "Akaun tidak aktif.",
  campaignNotExists: "Kempen tidak wujud.",
  paymentProviderNotExists: "Penyedia pembayaran tidak wujud.",
  profileInactive: "Profil tidak aktif.",
  minWithdrawalNotMet: "Pengeluaran minimum tidak dipenuhi.",
  invalidBankId: "ID bank tidak sah.",
  bankAccountExists: "Akaun bank wujud.",
  bankAccountFull: "Akaun bank penuh.",
  bankAccHolderNotSame: "Pemegang akaun bank tidak sama.",
  exceedMaxWithdrawal: "Melebihi pengeluaran maksimum.",
  exceedWithdrawalFrequency: "Melebihi kekerapan pengeluaran.",
  invalidPackage: "Pakej tidak sah.",
  promotionNotAvailable: "Promosi tidak tersedia.",
  ongoingPromotion: "Promosi sedang berlangsung.",
  pendingResultInGame: "Keputusan dalam permainan tertunda.",
  labelNameExists: "Nama label wujud.",
  labelNotExists: "Label tidak wujud.",
  invalidFtdMin: "Minimum deposit pertama tidak sah.",
  invalidFtdMax: "Maximum deposit pertama tidak sah.",
  ftdMinGtFtdMax: "Minimum deposit pertama lebih besar daripada maksimum.",
  vipFull: "VIP penuh.",
  invalidRewardType: "Jenis ganjaran tidak sah.",
  vipExists: "VIP wujud.",
  vipNotExists: "VIP tidak wujud.",
  onlyOneMaxWithdrawSetting: "Hanya satu tetapan pengeluaran maksimum dibenarkan.",
  onlyOneWithholdSetting: "Hanya satu tetapan withholding dibenarkan.",
  campaignExists: "Kempen wujud.",
  vipProviderNotExists: "Penyedia VIP tidak wujud.",
  turnoverTierExists: "Tahap turnover wujud.",
  turnoverTierFull: "Tahap turnover melebihi tahap maksimum.",
  turnoverTierNotExists: "Tahap turnover tidak wujud.",
  invalidSettingValue: "Nilai tetapan tidak sah.",
  turnoverTierNotSet: "Tahap turnover tidak ditetapkan.",
  rebateProcessed: "Rebat diproses.",
  invalidActionType: "Jenis tindakan tidak sah.",
  invalidRescueCycle: "Siklus penyelamatan tidak sah.",
  invalidPayoutMethod: "Kaedah pembayaran tidak sah.",
  invalidTargetGroup: "Kumpulan sasaran tidak sah.",
  rescueExists: "Rescue wujud.",
  rescueNotExists: "Rescue tidak wujud.",
  walletExists: "Dompet wujud.",
  accountExists: "Akaun wujud.",
  activeFromGtActiveTo: "Aktif dari lebih besar daripada aktif ke.",
  accountNotExists: "ID pengendali tidak wujud.",
  invalidDeposit: "Deposit tidak sah.",
  invalidTurnover: "Turnover tidak sah.",
  providerCodeNotExists: "Kod penyedia tidak wujud.",
  gameNameExists: "Nama permainan wujud.",
  gameNameNotExists: "Nama permainan tidak wujud.",
  invalidAccountType: "Jenis akaun tidak sah.",
  invalidLoginIdFormat: "Format ID log masuk tidak sah.",
  invalidReferralCode: "Kod rujukan tidak sah.",
  firstDepositNotMet: "Deposit pertama tidak dipenuhi.",
  newbieNotMet: "Syarat newbie tidak dipenuhi.",
  claimPromoOnlyOnce: "Tuntut promosi hanya sekali.",
  promotionRequirementNotMet: "Syarat promosi tidak dipenuhi.",
  withdrawalAmountLteWithholdAmount: "Jumlah pengeluaran kurang daripada atau sama dengan jumlah yang ditahan.",
  subAccountInactive: "Akaun sub tidak aktif.",
  gameNotSupported: "Permainan tidak disokong.",
  startTimeGteEndTime: "Masa mula lebih besar atau sama dengan masa tamat.",
  invalidPromotionType: "Jenis promosi tidak sah.",
  invalidClaimType: "Jenis tuntutan tidak sah.",
  claimLimitExceeded10: "Had tuntutan melebihi 10.",
  verificationFailed: "Pengesahan gagal.",
  claimLimitReached: "Had tuntutan telah dicapai.",
  invalidPromotion: "Promosi tidak sah.",
  socialPlatformExists: "Platform sosial wujud.",
  duplicateReview: "Ulasan pendua.",
  invalidSurveyId: "ID tinjauan tidak sah.",
  accountNotBlock: "Akaun tidak disekat.",
  walletNotExists: "Wang tidak wujud.",
  socialPlatformNotExists: "Platform sosial tidak wujud.",
  socialPlatformInactive: "Platform sosial tidak aktif.",
  accountSocialExists: "Akaun sosial wujud.",
  invalidStatus: "Status tidak sah.",
  samePassword: "Kata laluan sama.",
  invalidPassword: "Nama Pengguna atau Kata Laluan Tidak Sah.",
  secondaryAccountExists: "Akaun sekunder wujud.",
  invalidSecurityCode: "Kod keselamatan tidak sah.",
  accountSocialNotExists: "Akaun sosial tidak wujud.",
  providerInactive: "Penyedia tidak aktif.",
  gameIdExists: "ID Permainan wujud.",
  gameIdNotExists: "ID Permainan tidak wujud.",
  parentProviderInactive: "Penyedia induk tidak aktif.",
  betLimitNotExists: "Had pertaruhan tidak wujud.",
  min3Characters: "Minimum 3 aksara.",
  invalidBankAccType: "Jenis akaun bank tidak sah.",
  senderBankNotExists: "Bank pengirim tidak wujud.",
  recipientBankNotExists: "Bank penerima tidak wujud.",
  affiliateNotExists: "Rakan kongsi tidak wujud.",
  redepositedTicket: "Tiket yang disetorkan semula.",
  invalidDepositType: "Jenis deposit tidak sah.",
  affiliateInactive: "Rakan kongsi tidak aktif.",
  bonusUnavailable: "Bonus tidak tersedia.",
  pendingDeposit: "Deposit tertunda.",
  noOngoingPromotion: "Tidak ada promosi yang sedang berlangsung.",
  iframeNotExists: "IFrame tidak wujud.",
  gameMaintenance: "Penyelenggaraan permainan.",
  labelInactive: "Label tidak aktif.",
  invalidDomainType: "Jenis domain tidak sah.",
  invalidModule: "Modul tidak sah.",
  labelFull: "Label penuh.",
  questionExists: "Soalan wujud.",
  questionFull: "Soalan penuh.",
  questionNotExists: "Soalan tidak wujud.",
  reviewNotExists: "Tinjauan tidak wujud.",
  invalidDomainGroup: "Kumpulan domain tidak sah.",
  invalidDateRange: "Julat tarikh tidak sah.",
  ipAddressNotExists: "Alamat IP tidak wujud.",
  marqueeNotExists: "Marquee tidak wujud.",
  invalidAmount: "Jumlah tidak sah.",
  insufficientBalance: "Baki tidak mencukupi.",
  minLimitLtParent: "Had minimum kurang daripada ibu.",
  maxLimitGtParent: "Had maksimum lebih daripada ibu.",
  startDateGtEndDate: "Tarikh mula lebih besar daripada tarikh tamat.",
  currencyNotExists: "Mata wang tidak wujud.",
  currencyExists: "Mata wang wujud.",
  noAccumulateWin: "Tidak ada kemenangan terkumpul.",
  invalidSession: "Sesi tidak sah.",
  sessionExpired: "Sesi tamat.",
  promotionExists: "Promosi wujud.",
  invalidCriteria: "Kriteria tidak sah.",
  promotionNotExists: "Promosi tidak wujud.",
  ticketNotExists: "Tiket tidak wujud.",
  duplicateDebitRecord: "Rekod debit pendua.",
  duplicateCreditRecord: "Rekod kredit pendua.",
  debitRecordNotExists: "Rekod debit tidak wujud.",
  minDepositNotMet: "Deposit minimum tidak dipenuhi.",
  duplicateBet: "Pertaruhan duplikat.",
  invalidProviderCode: "Kod penyedia tidak sah.",
  resultExists: "Hasil wujud.",
  unableSPProcess: "Sistem tidak dapat memproses permintaan anda.",
  authRequired: "Kod pengesahan diperlukan.",
  domainExists: "Domain sudah wujud.",
  multiSelectOption: "Sila pilih {fname}",
  invalidDomainFormat: "Format Domain Tidak Sah",
  noHttpHttps: "'https://' atau 'http://' tidak dibenarkan.",
  noReservedSubdomain: "Subdomain yang telah ditempah tidak dibenarkan. Untuk penggunaan pautan muat turun aplikasi.",
  operatorInactive: "Pengendali tidak aktif",
  invalidAccountIdFormat: "Format ID Akaun tidak sah",
  contentIdRequired: "ID Menu diperlukan",
  themeCodeRequired: "Kod tema diperlukan",
  themeNameRequired: "Nama tema diperlukan",
  themeColorRequired: "Warna tema diperlukan",
  languageRequired: "Bahasa diperlukan",
  positionRequired: "Posisi diperlukan",
  themeContentIdRequired: "ID kandungan tema diperlukan",
  emailRequired: "Emel diperlukan",
  themeProviderTypeRequired: "Jenis penyedia tema diperlukan",
  phoneRequired: "Telefon diperlukan",
  targetTypeRequired: "Jenis sasaran diperlukan",
  packageTypeRequired: "Jenis pakej diperlukan",
  renewTermRequired: "Tempoh pembaharuan diperlukan",
  packagePriceRequired: "Harga pakej diperlukan",
  packageStatusRequired: "Status pakej diperlukan",
  sortKeyRequired: "Kunci susunan diperlukan",
  invalidDomainStatus: "Status domain tidak sah",
  invalidCurrency: "Mata wang tidak sah",
  invalidThemeCode: "Kod tema tidak sah",
  invalidLanguage: "Bahasa tidak sah",
  invalidPosition: "Posisi tidak sah",
  invalidThemeContent: "Kandungan tema tidak sah",
  allParamsSameAsCurrent: "Tidak ada perubahan",
  invalidThemeColor: "Warna tema tidak sah",
  invalidCartStatus: "Status troli tidak sah",
  invalidThemeProviderType: "Jenis penyedia tema tidak sah",
  themeProviderTypeCannotBeUse: "Jenis penyedia tema tidak boleh digunakan",
  invalidUserStatus: "Status pengguna tidak sah",
  packageCannotBeRemove: "Pakej tidak boleh dipadam",
  userStatusIsAlrdSuspend: "Pengguna sudah digantung",
  userStatusIsAlrdBlocked: "Pengguna sudah disekat",
  userStatusIsAlrdActive: "Pengguna sudah aktif",
  invalidSortType: "Jenis susunan tidak sah",
  startDateBiggerThanEndDate: "Tarikh mula lebih besar daripada tarikh tamat",
  positionCannotBeUse: "Posisi tidak boleh digunakan",
  funcAddContentFailed: "Gagal menambah kandungan",
  funcDeleteContentFailed: "Gagal memadam kandungan",
  funcUpdateContentFailed: "Gagal mengemas kini kandungan",
  funcAddThemeFailed: "Gagal menambah tema",
  funcDeleteThemeFailed: "Gagal memadam tema",
  funcUpdateThemeFailed: "Gagal mengemas kini tema",
  funcAddThemeColorFailed: "Gagal menambah warna tema",
  funcDeleteThemeColorFailed: "Gagal memadam warna tema",
  funcUpdateThemeColorFailed: "Gagal mengemas kini warna tema",
  funcAddLanguageFailed: "Gagal menambah bahasa",
  funcDeleteLanguageFailed: "Gagal memadam bahasa",
  funcUpdateLanguageFailed: "Gagal mengemas kini bahasa",
  funcAddThemeContentFailed: "Gagal menambah kandungan tema",
  funcDeleteThemeContentFailed: "Gagal memadam kandungan tema",
  funcUpdateThemeContentFailed: "Gagal mengemas kini kandungan tema",
  funcAddContentPositionFailed: "Gagal menambah posisi kandungan",
  funcUpdateContentPositionFailed: "Gagal mengemas kini posisi kandungan",
  funcDeleteContentPositionFailed: "Gagal memadam posisi kandungan",
  funcAddThemeProviderTypeFailed: "Gagal menambah jenis penyedia tema",
  funcUpdateThemeProviderTypeFailed: "Gagal mengemas kini jenis penyedia tema",
  funcDeleteThemeProviderTypeFailed: "Gagal memadam jenis penyedia tema",
  funcAddPackageFailed: "Gagal menambah pakej",
  funcUpdatePackageFailed: "Gagal mengemas kini pakej",
  funcDeletePackageFailed: "Gagal memadam pakej",
  nicknameRequired: "Nama samaran diperlukan",
  accountStatusRequired: "Status akaun diperlukan",
  contentIdMaxLength50: "Panjang maksimum ID menu adalah 50",
  positionMaxLength10: "Panjang maksimum jawatan adalah 10",
  contentDescMaxLength200: "Panjang maksimum penerangan kandungan adalah 200",
  domainStatusRequired: "Status domain diperlukan",
  funcAddDomainFailed: "Gagal menambah domain",
  funcUpdateDomainFailed: "Gagal mengemas kini domain",
  uploadFailed: "Gagal memuat naik!",
  sortKeyMaxLength50: "Kunci susun maksimum panjangnya adalah 50",
  invalidSortTypeFormat: "Format jenis susun tidak sah",
  invalidPackageId: "ID pakej tidak sah",
  invalidAccountStatusFormat: "Format status akaun tidak sah",
  invalidSiteStatusFormat: "Format status laman tidak sah",
  invalidPackageStatus: "Status pakej tidak sah",
  invalidEmailFormat: "Format email tidak sah",
  invalidPhoneFormat: "Format telefon tidak sah",
  languageLengthNotInRange: "Panjang bahasa tidak dalam julat (2-5)",
  languageDescriptionMaxLength50: "Panjang maksimum keterangan bahasa adalah 50",
  remarkMaxLength500: "Panjang maksimum ulasan adalah 500",
  themeProviderTypeMaxLength50: "Panjang maksimum jenis penyedia tema adalah 50",
  themeNameMaxLength50: "Panjang maksimum nama tema adalah 50",
  themeColorMaxLength20: "Panjang maksimum warna tema adalah 20",
  noSpace: "Tidak boleh mengandungi ruang",
  packageDescEnRequired: "Nama dalam Bahasa Inggeris diperlukan",
  packageDescEnMaxLength20: "Nama dalam Bahasa Inggeris maksima panjang 20",
  allParamsIsNull: "Semua parameter adalah null",
  contentCannotBeRemove: "Kandungan tidak boleh dipadam",
  contentDetailsRequired: "Maklumat kandungan diperlukan",
  domainCannotBeUse: "Domaine tidak boleh digunakan",
  domainGroupMaxLength20: "Kumpulan domain maksima panjang 20",
  domainGroupRequired: "Kumpulan domain diperlukan",
  domainNameCannotUpdate: "Nama domain tidak boleh dikemas kini",
  domainNameMaxLength400: "Panjang maksimum nama domain adalah 400",
  domainsRequired: "Domain diperlukan",
  domainStatusMaxLength20: "Panjang maksimum status domain adalah 20",
  domainTypeMaxLength10: "Panjang maksimum jenis domain adalah 10",
  funcAddThemeContentGroupFailed: "Gagal menambah kumpulan kandungan tema",
  funcDeleteThemeContentGroupFailed: "Gagal memadam kumpulan kandungan tema",
  funcOpsiteUpdateFailed: "Gagal mengemas kini opsite",
  funcResetAccountPasswordFailed: "Gagal menetapkan semula kata laluan akaun",
  funcSiteLanguageUpsertFailed: "Gagal mengemas kini bahasa laman",
  funcSiteThemeContentUpsertFailed: "Gagal mengemas kini kandungan tema laman",
  funcSiteThemeUpsertFailed: "Gagal mengemas kini tema laman",
  funcSiteUpdateFailed: "Gagal mengemas kini laman",
  funcUpdateAccountFailed: "Gagal mengemas kini akaun",
  funcUpdateAccountStatusActiveFailed: "Gagal mengemas kini status akaun kepada aktif",
  funcUpdateAccountStatusCompanyBlockFailed: "Gagal mengemas kini status akaun kepada blok syarikat",
  funcUpdateAccountStatusSuspendFailed: "Gagal mengemas kini status akaun kepada digantung",
  funcUpdateThemeContentGroupFailed: "Gagal mengemas kini kumpulan kandungan tema",
  invalidBoDomain: "Domain BO tidak sah",
  invalidOperatorIdFormat: "Format ID pengendali tidak sah",
  invalidOpsite: "Opsite tidak sah",
  invalidOpsiteOperator: "Pengendali opsite tidak sah",
  invalidOpsiteVersion: "Versi opsite tidak sah",
  invalidParentContentInGroup: "Kandungan induk dalam kumpulan tidak sah",
  invalidSite: "Laman tidak sah",
  invalidSiteStatus: "Status laman tidak sah",
  invalidThemeContentGroup: "Kumpulan kandungan tema tidak sah",
  languageCannotBeUse: "Bahasa tidak boleh digunakan",
  languagesRequired: "Bahasa diperlukan",
  logo1Required: "Logo diperlukan",
  notSupportMultiDefault: "Multi-default tidak disokong",
  operatorIdMaxLength50: "Panjang maksimum ID operator adalah 50",
  opsiteNotMatch: "Opsite tidak sepadan",
  packageTypeMaxLength15: "Panjang maksimum jenis pakej adalah 15",
  parentContentIdCannotSameWithContentId: "ID kandungan induk tidak boleh sama dengan ID kandungan",
  phoneNumberRequired: "Nombor telefon diperlukan",
  siteIdRequired: "ID Laman diperlukan",
  siteNameMaxLength50: "Panjang maksimum nama laman adalah 50",
  siteNameRequired: "Nama laman diperlukan",
  technicalError: "Ralat teknikal",
  themeCannotBeRemove: "Tema tidak boleh dipadam",
  themeCodeCannotBeUse: "Kod tema tidak boleh digunakan",
  themeCodeMaxLength20: "Panjang maksimum kod tema adalah 20",
  themeColorCannotBeRemove: "Warna tema tidak boleh dipadam",
  themeColorCannotBeUse: "Warna tema tidak boleh digunakan",
  themeContentCannotBeUse: "Kandungan tema tidak boleh digunakan",
  themeContentGroupCannotBeUse: "Kumpulan kandungan tema tidak boleh digunakan",
  themeContentGroupDescriptionMaxLength50: "Panjang maksimum keterangan kumpulan kandungan tema adalah 50",
  themeContentGroupMaxLength20: "Panjang maksimum kumpulan kandungan tema adalah 20",
  themeContentGroupRequired: "Kumpulan kandungan tema diperlukan",
  themeNameCannotBeUse: "Nama tema tidak boleh digunakan",
  userHaventVerifyThisBefore: "Pengguna belum mengesahkan ini sebelum ini",
  isDefaultTrueRequired: "Bahasa mesti mempunyai 1 lalai",
  accountIdMaxLength50: "Panjang maksimum ID pengguna adalah 50",
  headBodyScriptEitherOne: "Sila masukkan Skrip Kepala atau Skrip Badan",
  alphaOrNum: "Hanya boleh menggunakan huruf atau nombor sahaja,",
  phoneValid: "Sila masukkan Nombor Telefon yang sah",
  permittedAmountRequired: "Jumlah yang dibenarkan diperlukan",
  ignoreRiskRequired: "Risiko yang diabaikan diperlukan",
  paymentDescRequired: "Deskripsi pembayaran diperlukan",
  gameTypeRequired: "Jenis permainan diperlukan",
  statusRequired: "Status diperlukan",
  payoutIdRequired: "Id pembayaran diperlukan",
  commNotExists: "Komisen tidak wujud",
  parentCommNotExists: "Komisen induk tidak wujud",
  carryOverNotExists: "Bawa ke depan tidak wujud",
  hotGameExists: "Permainan panas sudah wujud",
  commSportsExceededParent: "Komisen untuk sukan melebihi ibu bapa",
  commSlotsExceededParent: "Komisen untuk slot melebihi ibu bapa",
  commLivecasinoExceededParent: "Komisen untuk kasino langsung melebihi ibu bapa",
  commCockfightExceededParent: "Komisen untuk sabung ayam melebihi ibu bapa",
  commOthersExceededParent: "Komisen untuk lain-lain melebihi ibu bapa",
  hotGameNotExists: "Permainan panas tidak wujud",
  noSecurityDeposit: "Tiada dana keselamatan",
  exchangeRateNotExists: "Kadar pertukaran tidak wujud",
  insufficientSecurityDeposit: "Dana keselamatan tidak mencukupi",
  duplicateDomain: "Domain pendua",
  contactEmailNotExists: "Email hubungan tidak wujud",
  featuredGameNotExists: "Permainan ciri tidak wujud",
  newGameNotExists: "Permainan baru tidak wujud",
  popularGameNotExists: "Permainan popular tidak wujud",
  featuredGameExists: "Permainan ciri sudah wujud",
  newGameExists: "Permainan baru sudah wujud",
  popularGameExists: "Permainan popular sudah wujud",
  rebateNotExists: "Rebat tidak wujud",
  riskyMember: "Ahli berisiko",
  ipRestricted: "IP terhad",
  notSupportedBank: "Bank tidak disokong.",
  requestTooFrequent: "Permintaan terlalu kerap.",
  paymentOptionNotExists: "Pilihan pembayaran tidak wujud.",
  earningIdRequired: "ID Pendapatan diperlukan.",
  ptOnRequired: "PT On diperlukan.",
  ptRequired: "PT diperlukan.",
  userIdRequired: "ID Pengguna diperlukan.",
  businessIdRequired: "ID Perniagaan diperlukan.",
  subAccountIdRequired: "ID Akaun Sub diperlukan.",
  sourceAccountIdRequired: "ID Akaun Sumber diperlukan.",
  targetAccountIdRequired: "ID Akaun Sasaran diperlukan.",
  ticketTaken: "Tiket telah diambil",
  ticketNotTaken: "Tiket belum diambil",
  invalidPt: "PT tidak sah",
  topupIdRequired: "ID tambah nilai diperlukan",
  promotionMemberLogNotExists: "Log ahli promosi tidak wujud",
  paymentOptionInactive: "Pilihan Pembayaran Tidak Aktif",
  invalidCartStatusFormat: "Format status troli tidak sah",
  requestIncompleted: 'Permintaan Tidak Lengkap',
  unknownError: 'Ralat tidak diketahui telah berlaku',
  cartIdRequired: "ID Troli diperlukan",
  stepNameRequired: "Nama langkah diperlukan",
  invalidCart: "Troli tidak sah",
  invalidStepName: "Nama langkah tidak sah",
  cartHaventSetupComplete: "Tetapan troli belum lengkap",
  funcCartCreateFailed: "Gagal membuat troli",
  funcCartUpdateFailed: "Gagal mengemas kini troli",
  funcSiteCreateFailed: "Gagal membuat laman web",
  funcCartPurchasedUpdateFailed: "Gagal mengemas kini pembelian troli",
  invalidPasswordFormat: "Format kata laluan tidak sah",
  currencyCodeRequired: "Mata wang diperlukan",
  funcCartLanguageUpsertFailed: "Gagal mengemas kini bahasa troli",
  invalidUserIdFormat: "Format ID Pengguna tidak sah",
  operatorPasswordRequired: "Kata laluan operator diperlukan",
  funcCartOperatorInfoUpsertFailed: "Gagal mengemas kini maklumat operator troli",
  invalidOperatorPasswordFormat: "Format kata laluan operator tidak sah",
  operatorIdCannotBeUse: "ID Operator tidak boleh digunakan",
  siteNameLengthNotInRange: "Panjang Nama Laman tidak dalam julat yang ditetapkan",
  userIdCannotBeUse: "ID Pengguna tidak boleh digunakan",
  siteIdAlrdExist: "ID Laman sudah wujud",
  operatorIdAlrdExist: "ID Operator sudah wujud",
  externalIdAlrdExist: "ID Luaran sudah wujud",
  opsiteContentAlrdExist: "Kandungan tema laman web sudah wujud",
  opsiteLanguageAlrdExist: "Bahasa kandungan laman web sudah wujud",
  boAccountAlrdExist: "Akaun BO sudah wujud",
  boAccountProfileAlrdExist: "Profil akaun BO sudah wujud",
  boAccountLoginAlrdExist: "Log masuk akaun BO sudah wujud",
  funcCartThemeCodeUpsertFailed: "Gagal mengemas kini tema troli",
  funcCartThemeColorUpsertFailed: "Gagal mengemas kini warna troli",
  funcOpsiteCreateFailed: "Gagal membuat kandungan laman web",
  alphabetValid: "Mesti mempunyai sekurang-kurangnya satu huruf besar dan satu huruf kecil",
  numberValid: "Mesti mempunyai sekurang-kurangnya satu nombor",
  symbolValid: "Mesti mempunyai sekurang-kurangnya satu simbol",
  credentialNotSet: "Kredensial tidak ditetapkan",
  validBankAccFormat: "Format No. Akaun Bank tidak sah",
  moreThan: "{fname} mesti kurang daripada atau sama dengan {fname2}",
  lessThan: "{fname} mesti lebih daripada atau sama dengan {fname2}.",
  bankAccountNotAvailable: "Akaun bank tidak tersedia.",
  insufficientCredit: "Kredit Tidak Mencukupi",
  enableRequired: "Perlu diaktifkan.",
  funcAddGameFailed: "Gagal menambah permainan.",
  funcAddGameRewardByBatchFailed: "Gagal menambah ganjaran permainan secara kelompok.",
  funcAddGameRewardFailed: "Gagal menambah ganjaran permainan.",
  funcAddGameTemplateFailed: "Gagal menambah templat permainan.",
  funcAddLayoutTemplateFailed: "Gagal menambah templat susun atur.",
  funcAddOperatorGameFailed: "Gagal menambah permainan operator.",
  funcAddOperatorMemberWalletFailed: "Gagal menambah dompet ahli operator.",
  funcDeleteGameFailed: "Gagal memadam permainan.",
  funcDeleteGameRewardFailed: "Gagal memadam ganjaran permainan.",
  funcDeleteGameTemplateFailed: "Gagal memadam templat permainan.",
  funcDeleteLayoutTemplateFailed: "Gagal memadam templat susun atur.",
  funcDeleteOperatorGameFailed: "Gagal memadam permainan operator.",
  funcUpdateGameFailed: "Gagal mengemas kini permainan.",
  funcUpdateGameRewardFailed: "Gagal mengemas kini ganjaran permainan.",
  funcUpdateGameTemplateFailed: "Gagal mengemas kini templat permainan.",
  funcUpdateLayoutTemplateFailed: "Gagal mengemas kini templat susun atur.",
  funcUpdateOperatorGameFailed: "Gagal mengemas kini permainan operator.",
  gameCannotBeRemove: "Permainan tidak boleh dipadam.",
  gameNameCannotBeUse: "Nama permainan tidak boleh digunakan.",
  gameNameMaxLength150: "Nama permainan mestilah maksimum 150 aksara.",
  gameRewardCannotBeUse: "Ganjaran permainan tidak boleh digunakan.",
  gameRewardLimitExceeded: "Had ganjaran permainan telah melebihi.",
  gameTemplateExist: "Templat permainan sudah wujud.",
  gameTypeMaxLength20: "Jenis permainan mestilah maksimum 20 aksara.",
  invalidGame: "Permainan tidak sah.",
  invalidGameReward: "Ganjaran permainan tidak sah.",
  invalidGameTemplate: "Templat permainan tidak sah.",
  invalidMemberWallet: "Dompet ahli tidak sah.",
  invalidOperatorGame: "Permainan operator tidak sah.",
  invalidRewardProbability: "Kebarangkalian ganjaran tidak sah.",
  invalidTemplate: "Templat tidak sah.",
  maxGameRewardRequired: "Ganjaran maksimum permainan diperlukan.",
  maxMiniGameRewardRequired: "Ganjaran maksimum mini-permainan diperlukan.",
  memberWalletAlrdExist: "Dompet ahli sudah wujud.",
  operatorGameCannotBeUse: "Permainan operator tidak boleh digunakan.",
  operatorGameIdRequired: "ID permainan operator diperlukan.",
  rewardCodeMaxLength20: "Kod ganjaran mestilah maksimum 20 aksara.",
  rewardCodeRequired: "Kod ganjaran diperlukan.",
  rewardCurrencyMaxLength5: "Mata wang ganjaran mestilah maksimum 5 aksara.",
  rewardCurrencyRequired: "Mata wang ganjaran diperlukan.",
  rewardDescriptionMaxLength100: "Penerangan ganjaran mestilah maksimum 100 aksara.",
  rewardNameMaxLength50: "Nama ganjaran mestilah maksimum 50 aksara.",
  rewardProbabilityRequired: "Kebarangkalian ganjaran diperlukan.",
  rewardRequired: "Ganjaran diperlukan.",
  selectedTemplateMaxLength30: "Templat yang dipilih mestilah maksimum 30 aksara.",
  selectedTemplateRequired: "Templat yang dipilih diperlukan.",
  success: "Berjaya.",
  templateCannotBeRemove: "Templat tidak boleh dipadam.",
  templateCodeCannotBeUse: "Kod templat tidak boleh digunakan.",
  templateCodeMaxLength30: "Kod templat mestilah maksimum 30 aksara.",
  templateCodeRequired: "Kod templat diperlukan.",
  templateNameMaxLength50: "Nama templat mestilah maksimum 50 aksara.",
  tokenRequestRequired: "Permintaan token diperlukan.",
  tokenRequired: "Token diperlukan.",
  mustMoreThan: "{fname} mesti lebih daripada {fname2}.",
  mustMoreThanOrEqual: "{fname} mesti lebih daripada atau sama dengan {fname2}.",
  tokenInvalid: "Input token tidak sah pada {key}",
  cashInvalid: "Input tunai tidak sah pada {key}",
  atLeastOneRequired: "Sekurang-kurangnya satu diperlukan",
  cash1To7Required: "Cash 1 hingga 7 diperlukan",
  cash1To6Required: "Cash 1 hingga 6 diperlukan",
  cash1To5Required: "Cash 1 hingga 5 diperlukan",
  cash1To4Required: "Cash 1 hingga 4 diperlukan",
  cash1To3Required: "Cash 1 hingga 3 diperlukan",
  cash1To2Required: "Cash 1 hingga 2 diperlukan",
  cash1Required: "Cash 1 diperlukan",
  token1To7Required: "Token 1 hingga 7 diperlukan",
  token1To6Required: "Token 1 hingga 6 diperlukan",
  token1To5Required: "Token 1 hingga 5 diperlukan",
  token1To4Required: "Token 1 hingga 4 diperlukan",
  token1To3Required: "Token 1 hingga 3 diperlukan",
  token1To2Required: "Token 1 hingga 2 diperlukan",
  token1Required: "Token 1 diperlukan",
  cycleRequired: "Kitaran diperlukan",
  targetAmountRequired: "Jumlah sasaran diperlukan",
  gamifyIdRequired: "ID Ganjaran diperlukan",
  gamifyMemberProcessed: "Ahli ganjaran telah diproses",
  gamifyNotExists: "Ganjaran tidak wujud",
  gamifyInactive: "Ganjaran tidak aktif",
  invalidCycle: "Kitaran tidak sah",
  memberIdMaxLength50: "ID Ahli tidak boleh melebihi 50 aksara",
  funcAddGameWalletFreeCreditFailed: "Gagal menambah kredit percuma ke dompet permainan",
  funcUpdateOperatorMemberWalletBalanceFailed: "Gagal mengemas kini baki dompet ahli operator",
  funcUpdateOperatorMemberWalletBalanceByFrozenFailed: "Gagal mengemas kini baki dompet ahli operator berdasarkan jumlah beku",
  mustHaveBothAlphaNumOnly: "Hanya gunakan huruf dan nombor, dengan sekurang-kurangnya satu setiap satu.",
  setupGameRewardBeforeEnable: "Sila tetapkan ganjaran permainan sebelum mengaktifkannya.",
  rewardProbabilityMustNotAllZero: "Kebarangkalian ganjaran tidak boleh semuanya sifar.",
  totalRewardProbabilityCannotOver100: "Jumlah kebarangkalian ganjaran tidak boleh melebihi 100.",
  credential1To2Required: "Kelayakan 1 hingga 2 diperlukan.",
  credential1To4Required: "Kelayakan 1 hingga 4 diperlukan.",
  newRemarkRequired: "Catatan diperlukan.",

  notSupportedWithdrawalPG: "Gerbang pembayaran pengeluaran yang tidak disokong."
};